'use strict';

import movieBrowseLayout from 'templates/movieBrowse/movieBrowseLayout.tpl';
import movieBrowseItem from 'templates/movieBrowse/__movieBrowseItem.tpl';
import 'components/subnav';
import BreakPoints from 'helpers/breakpoints';
import Domain from 'helpers/Domain';
import GridImpressionTracking, { hasGridImpressionTracking } from 'shared/gridImpressionTracking';
import GridFathomTracking from 'shared/gridFathomTracking';

/**
 * MovieBrowse component class
 */
export default class MovieBrowse {
    constructor() {
        //prevents safari from using cache. this way it will scroll to the correct position.
        $(window).bind('pageshow', function (event) {
            if (event.originalEvent.persisted) {
                window.location.reload();
            }
        });

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        this._routePrefix = CBS.Registry.region.prefix + '/movies_xhr/';
        if (window.localStorage.getItem('set_continuous_movie')) {
            window.localStorage.removeItem('set_continuous_movie');
        }

        this.hasImpresionTracking = hasGridImpressionTracking(true);
        this.fathomTracking = null;
        this.impressionTracking = null;

        this.init();
        if (!CBS.Registry.Features.browse_microgenre_carousels_enabled) {
            this.__setupButtons();
        }

        window.onpopstate = function (stateObj) {
            this._setCategory(stateObj.state ? stateObj.state.category : this.initialCategory);
            if (this._getCategory() == undefined) {
                window.location.replace(stateObj.state.urlPath);
                return;
            }
            this.__setNextRouteXHR(this._getCategory());
            this.updateSubnavState();
            this.doAjax(false);
        }.bind(this);

        // trigger image revalidate on render complete event
        $(this).on('movieBrowseDidRender', function () {
            if (CBS.Registry.lazyImage !== undefined) {
                setTimeout(() => {
                    CBS.Registry.lazyImage.revalidate();
                }, 200);
            }
        });
    }

    /**
     * Initialize lazy load images
     */
    __initiateVars() {
        this.brazeCampaignParams = { screenName: 'movies browse' };
        this.metaTitle = $('title');
        this.metaDesc = $('meta[name="description"]');
        this.metaOgTitle = $('meta[property="og:title"]');
        this.metaOgDesc = $('meta[property="og:description"]');

        // used as suffix to ajax calls
        this.route = '';
        this.nextRoute = '';
        this.nextRouteXHR = '';

        this.start = 0;
        this.movieLoadSize = 42; // should match MoviesManager
        this.loadMore = true;
        this.number_found = 0;

        // category to fetch (and returned)
        this.category = '';
        this.urlPath = null;

        // ajax resp
        this.resp = '';
        this.doingLoadingMore = false;

        // subnav buttons
        this.buttons = $('.subnav__items a');

        // parent rendering container
        this.container = $('.movie-browse-container');
        this.gridContainer = $('.movie-browse-grid');

        this.setRoute();
        this.defaultCategory = 'popular';
        this.initialCategory = this.category;

        this.pageType =
            CBS.Registry.Features.browse_microgenre_carousels_enabled &&
            this.initialCategory != 'all'
                ? 'browse_door'
                : 'category_door';

        this._setupMovies(this.initialCategory);
        this.__scrollToPreviousSpot(this.initialCategory, this.start);
    }

    // scroll page to previous spot or page
    __scrollToPreviousSpot(category, start) {
        if (sessionStorage['scrollPosition_movies_' + category]) {
            $(document).scrollTop(sessionStorage.getItem('scrollPosition_movies_' + category));
        } else {
            try {
                if (start > 0) {
                    $(document).scrollTop($('#page' + start).offset().top - 50);
                }
            } catch (e) {}
        }
    }

    // setup the route suffix used for ajax call
    setRoute() {
        let category =
            $('.subnav__items li a.active').data('category') ?? this.gridContainer.data('category');
        this._setCategory(category);
    }

    init() {
        this.__initiateVars();
        this.__listenEvents();
        this.__initSubNavTracking();
        this.__initTracking(document.querySelectorAll('.movie-browse-item'));
        this.__initImpressionTracking();
        this.__initFathomTracking();
    }

    __initSubNavTracking() {
        $('.subnav__items li').on('click', function (e) {
            let element = $(e.currentTarget)[0];
            const col = $(element).prevAll('li').length.toString();
            const category = e.currentTarget.innerText;
            let trackParams = {
                menuItemLabel: `Movies-${category}`,
                menuOrientation: 'header',
                posColNum: col,
                posRowNum: '0',
                movieBrowseCategory: category.toLowerCase(),
            };

            if (typeof om != 'undefined') {
                om.trackAction('trackSubMenu', trackParams);
            }
            localStorage.setItem('trackSubMenu', JSON.stringify(trackParams));
        });
    }

    __initTracking(elements) {
        let _self = this;
        for (let i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', (event) => {
                let elem = elements[i];
                _self.trackBrowseTile(elem);
            });
        }
    }

    trackBrowseTile(el) {
        let _self = this;
        let $el = $(el);
        let $link = $el.find('a');
        let dd = $link.attr('aa-link');
        if (dd) {
            dd = dd.split('|');
        }

        let category = _self.category;

        var scrollPosition = $(document).scrollTop();
        sessionStorage.setItem('scrollPosition_movies_' + category, scrollPosition.toString());
        let section_title = $el.parent().prev().text();
        section_title = section_title.length === 0 ? this.initialCategory : section_title;

        let _parent = $el.parent();
        let _grandparent = _parent.parent();
        let _grids = _grandparent.find('div.movie-browse-grid');
        let rowNum;

        for (let i = 0; i < _grids.length; i++) {
            if (_parent[0] === _grids[i]) {
                rowNum = i;
            }
            rowNum = rowNum === 0 ? '0' : Number(rowNum); //tracking treats int 0 as boolean and doesn't capture the value
        }
        let _sibs = _parent.find('article.movie-browse-item');
        let colNum = 0;
        for (let i = 0; i < _sibs.length; i++) {
            if ($el[0] === _sibs[i]) {
                colNum = i;
            }
            colNum = colNum === 0 ? '0' : colNum;
        }

        let __contentBrand = dd[10];
        __contentBrand = __contentBrand !== '' ? __contentBrand : 'na';

        let rowHeaderTitle = category == 'all' || category == '' ? 'All Movies' : category;
        let badgeLabel = $link.find('.new-item').text();

        let trackParams = {
            pageType: _self.pageType,
            pageURL: '/movies/' + category + '/',
            screenName: 'movies/' + category,
            movieBrowseCategory: rowHeaderTitle,
            movieGenre: typeof dd[15] !== undefined ? dd[15] : '',
            movieId: typeof dd[16] !== undefined ? dd[16] : '',
            movieTitle: typeof dd[4] !== undefined ? dd[4] : '',
            PPlusSubscriberBadge: typeof dd[14] !== undefined ? dd[14] : '',
            rowHeaderTitle: rowHeaderTitle,
            posRowNum: rowNum,
            posColNum: colNum,
            contentBrand: __contentBrand,
            contentLocked: dd[23],
            contentBadgeLabel: badgeLabel ?? '',
        };

        if (typeof om != 'undefined') {
            om.trackAction('trackMovieBrowseTileSelect', trackParams);
        }
        localStorage.setItem('trackMovieBrowseTileSelect', JSON.stringify(trackParams));
    }

    __listenEvents() {
        $(this).on('movieBrowseDidRender', () => {
            // reinitialize blazy object
            if (CBS.Registry.lazyImage !== undefined) {
                setTimeout(() => {
                    CBS.Registry.lazyImage.revalidate();
                }, 100);
            }
        });
    }

    _setupMovies(cat) {
        let _self = this;

        $('#movie-browse-bottom').remove();

        cat = this._removeSlashesFromCategory(cat);

        if (cat === this.defaultCategory) {
            return;
        }

        if (_self.loadMore) {
            $(
                '<section id="movie-browse-bottom" class="padded-container browse-more-bottom"><a href="' +
                    '/movies/' +
                    cat +
                    '/' +
                    (_self.start + 1) +
                    '" id="movies_next" class="browse-more-bottom-btn button secondary load-more-button">Load More</a></section>',
            ).insertAfter('.movie-browse-container');

            $('#movies_next').click(function (e) {
                e.preventDefault();
                if (_self.doingLoadingMore !== true) {
                    _self.start += 1;
                    _self.__setNextRouteXHR(cat + '/' + _self.start);
                    _self.loadMoreToGrid();
                }
            });
        }

        let boxElement = document.querySelector('#movie-browse-bottom');
        let options = {
            root: null,
            rootMargin: '20px 0px 0px 0px',
            threshold: 0,
        };

        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (_self.doingLoadingMore !== true) {
                        _self.start += 1;
                        _self.__setNextRouteXHR(cat + '/' + _self.start);
                        _self.loadMoreToGrid();
                    }
                }
            });
        }, options);
        if (boxElement) observer.observe(boxElement);
        if (
            $('.no-movies').length ||
            $('.movie-browse-container').attr('data-movies-found') <= _self.movieLoadSize
        ) {
            $('#movie-browse-bottom').remove();
        }

        _self.setTrendingLimit();
    }

    __setupButtons() {
        let self = this;
        self.buttons.click((e) => {
            e.preventDefault();

            let btn = $(e.target);

            self.category = btn.data('category');

            const pathArray = window.location.pathname.split('/');
            let same =
                btn.attr('href').replace(/\/$/, '') == window.location.pathname.replace(/\/$/, '');

            if (!btn.hasClass('active') || !same) {
                sessionStorage.setItem('scrollPosition_movies_' + this._getCategory(), '0');
                $('#movie-browse-bottom').remove();
                self.start = 0;
                // update subnav styles
                self.buttons.removeClass('active');
                btn.addClass('active');

                // reset the route for the ajax call & push state
                self.nextRoute = btn.attr('href');
                self.__setNextRouteXHR(btn.data('category'));
                self.doAjax();
            }
        });
    }

    __setNextRouteXHR(category) {
        this.nextRouteXHR = this._routePrefix + category + '/';
    }

    doAjax(saveState) {
        let self = this;
        let route = self.nextRouteXHR;
        if (Domain.isInternational()) {
            route = route + self.start + '/';
        }
        saveState = typeof saveState === 'boolean' ? saveState : true;

        $.ajax({
            url: route,
            dataType: 'json',
        }).done((resp) => {
            this.resp = resp;
            if (this.resp.success) {
                $.each(this.resp.data, function (i, item) {
                    self.number_found = item.result.total;
                });
                $('.movie-browse-container').attr('data-movies-found', self.number_found);
                this.handleSuccess(saveState);
                this.destroyImpressionTracking();
                this.createImpressionTracking();
                this.destroyFathomTracking();
                this.createFathomTracking();
            } else {
                $('.movie-browse-container').attr('data-movies-found', 0);
                this.destroyImpressionTracking();
                this.destroyFathomTracking();
                this.clearGrid();
                this.saveState();
                $('.movie-browse-container').append(
                    "<div class='no-movies'> Sorry no movies found in that genre.</div>",
                );
                $('#movie-browse-bottom').remove();
            }
        });
    }
    loadMoreToGrid() {
        let _self = this;
        let route = _self.nextRouteXHR;

        _self.doingLoadingMore = true;

        $.ajax({
            url: route,
            dataType: 'json',
        })
            .done((resp) => {
                _self.resp = resp;
                _self._addToGrid(_self.gridContainer, _self.resp.data);
                $(_self).trigger('movieBrowseDidRender');
            })
            .always(function () {
                _self.doingLoadingMore = false;
            });
    }

    handleSuccess(saveState) {
        this.manipulateMeta();
        this.displayResults();
        // Set HUB data to Impression/Fathom Tracking
        this.updateUtagData();

        if (saveState === true) {
            this.saveState();
        }
    }

    saveState() {
        // push updated category, title, nextRoute
        window.history.pushState(
            { category: this._getCategory() },
            this.metaTitle.text(),
            this.nextRoute,
        );
        //update pageType
        this.trackView({
            pageType: self.pageType,
            siteHier: self.pageType,
            movieBrowseCategory: this._getCategory() == 'all' ? 'All Movies' : this._getCategory(),
            movieGenre: null,
            showGenre: null,
            pageUrl: window.location.protocol + '//' + window.location.host + this.nextRoute,
        });
    }

    manipulateMeta() {
        if (this.resp.seo) {
            let seo = this.resp.seo;
            this.metaTitle.text(seo.meta_title);
            this.metaDesc.attr('content', seo.meta_description);
            this.metaOgTitle.attr('content', seo.social_title);
            this.metaOgDesc.attr('content', seo.social_description);
        }
    }

    displayResults() {
        let self = this;
        $('#movie-browse-bottom').remove();
        // scroll user to top
        $('html, body').animate(
            {
                scrollTop: 0,
            },
            300,
        );

        // clear out existing results
        this.clearGrid();

        if (self._getCategory() == null) {
            self._setCategory(self.initialCategory);
        }
        self.displayCategory();
        setTimeout(function () {
            self._setupMovies(self.category);
        }, 2000);
    }

    updateSubnavState() {
        let self = this;
        this.buttons.each(function () {
            $(this).removeClass('active');
            if ($(this).data('category') === self.category) {
                $(this).addClass('active');
            }
        });
    }

    clearGrid() {
        this.container.html('');
    }

    updateUtagData() {
        if (CBS?.Tracking?.utag_data) {
            CBS.Tracking.utag_data.hubId = this?.resp?.hub?.id ?? '';
            CBS.Tracking.utag_data.hubSlug = this?.resp?.hub?.slug ?? '';
            CBS.Tracking.utag_data.title = this?.resp?.hub?.title ?? '';
        }
    }

    displayCategory() {
        if (this.number_found <= this.movieLoadSize) {
            $('#movie-browse-bottom').remove();
        }

        // render the grid for the selected category
        this.resp.data.forEach((section, position) => {
            section.result.position = position;
            this._renderGrid(this.container, section.result);
        });

        this.setTrendingLimit();

        $(this).trigger('movieBrowseDidRender');
    }

    renderMovieItemTemplate(obj) {
        return movieBrowseItem(obj);
    }

    _renderGrid(mountView, result) {
        let grid = '';

        // render the items to the grid container ^
        result.data.forEach((obj, idx) => {
            obj.pos = idx + 1;
            obj.category = this._getCategory();

            if (obj.href !== '') {
                grid += this.renderMovieItemTemplate(obj);
            }
        });

        let layout = $(movieBrowseLayout({ title: result.title }));
        let $grid = $(grid);
        this.__initTracking($grid);
        layout
            .filter('div.movie-browse-grid.grid.portrait')
            .attr('aa-region', result.category)
            // Impression/Fathom Tracking
            .attr('data-position', result?.position ?? 0)
            .attr('data-category', result?.category ?? '')
            .attr('data-pvrmodel', result?.pvrmodel ?? '')
            .attr('data-rankmodel', result?.rankmodel ?? '')
            .attr('data-recoId', result?.recoId ?? '')
            .attr('data-gridId', result?.gridId ?? '')
            .attr('data-type', result?.type ?? '')
            .attr('data-displayid', result?.displayid ?? '')
            .attr('data-title', result?.title ?? '')
            .attr('data-id', result?.id ?? '')
            // END Impression/Fathom Tracking
            .append($grid);
        mountView.append(layout);
    }

    _addToGrid(mountView, result) {
        let _data = result?.[0]?.result?.data; //We only display the main genre when adding to the grid

        let grid = '';
        let self = this;

        if (_data) {
            let nextUrl = CBS.Registry.region.prefix + '/movies/' + self.category + '/';
            nextUrl = this.start > 0 ? nextUrl + this.start : nextUrl;
            $('#movies_next').attr('href', nextUrl);

            if (!Domain.isInternational()) {
                history.replaceState({ urlPath: nextUrl }, '', nextUrl);
            }

            _data.forEach((obj, idx) => {
                obj.pos = idx + 1;
                obj.category = self.category;

                //check if item has link
                if (obj.href !== '') {
                    grid += movieBrowseItem(obj);
                }
            });

            let $grid = $(grid);
            this.__initTracking($grid);
            $('.movie-browse-grid:not(.trending)').append($grid);

            if (result[0].result.total <= this.gridContainer.children().length) {
                $('#movie-browse-bottom').remove();
            }
        } else {
            $('#movie-browse-bottom').remove();
        }
    }

    _removeSlashesFromCategory(category) {
        if (category) {
            category = category.replace('/', '');
        }
        return category;
    }

    _getCategory() {
        return this._removeSlashesFromCategory(this.category);
    }

    _setCategory(category = '') {
        this.category = category.endsWith('/') ? category.slice(0, -1) : category;
        // Triggers Braze event
        if (CBS.Registry.Features.braze_sdk === true) {
            import('shared/braze_events/events').then(({ onBrowsePageView }) =>
                onBrowsePageView(category, this.brazeCampaignParams),
            );
        }
        return this.category;
    }

    /**
     * Generic view tracking
     * @param {Object} params
     */
    trackView(params) {
        if (typeof om == 'undefined') {
            setTimeout(() => {
                if (typeof om != 'undefined') {
                    om.trackView(params);
                }
            }, 2000);
        } else {
            if (typeof om != 'undefined') {
                om.trackView(params);
            }
        }
    }

    /**
     * Trending section limited to 2 rows of items in the grid, at any breakpoint
     */
    setTrendingLimit() {
        window.onresize = this.setTrendingSectionLimit;
        this.setTrendingSectionLimit();
    }

    setTrendingSectionLimit() {
        let trendingItemsByBreakpoint = {
            mobilePortrait: 4,
            mobileLandscape: 6,
            tabletPortrait: 8,
            tabletLandscape: 10,
            desktop: 14,
            desktopWide: 14,
        };
        let b = new BreakPoints();
        let currentLimit = trendingItemsByBreakpoint[b.getCurrentBreakpointName()];

        let trendingItems = $('.movie-browse-grid.trending').find('.movie-browse-item');
        for (let i = 0; i < trendingItems.length; i++) {
            if (i < currentLimit) {
                $(trendingItems[i]).addClass('show');
            } else {
                $(trendingItems[i]).removeClass('show');
            }
        }
    }

    __initImpressionTracking() {
        if (this.hasImpresionTracking) {
            this.createImpressionTracking();
        }
    }

    destroyImpressionTracking() {
        if (this.impressionTracking) {
            this.impressionTracking.removeEvents();
            this.impressionTracking = null;
        }
    }

    createImpressionTracking() {
        const movieBrowseGrid = document.querySelectorAll('.movie-browse-grid');
        const trackingContainers = movieBrowseGrid.length ? [...movieBrowseGrid] : [];
        let objTracking = {
            pageType: CBS.Registry?.pageType ?? 'CATEGORY_DOOR',
        };

        this.impressionTracking = new GridImpressionTracking(
            trackingContainers,
            'carouselView',
            'carouselSelect',
            objTracking,
        );
    }

    __initFathomTracking() {
        if (this.hasImpresionTracking) {
            this.createFathomTracking();
        }
    }

    destroyFathomTracking() {
        if (this.fathomTracking) {
            this.fathomTracking.removeEvents();
            this.fathomTracking = null;
        }
    }

    createFathomTracking() {
        const trackingContainers = this.getTrackingContainers();
        this.fathomTracking = new GridFathomTracking(trackingContainers);
    }

    getTrackingContainers() {
        const movieBrowseGrid = document.querySelectorAll('.movie-browse-grid');

        if (movieBrowseGrid.length) return [...movieBrowseGrid];
        return [];
    }
}
